import { render } from "./attribute-pop.vue?vue&type=template&id=4492e054&scoped=true"
import script from "./attribute-pop.vue?vue&type=script&lang=js"
export * from "./attribute-pop.vue?vue&type=script&lang=js"

import "./attribute-pop.vue?vue&type=style&index=0&id=4492e054&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4492e054"

export default script